import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

interface Props {
  titleTranslationKey: string;
  subtitleTranslationKey: string;
}

export const LeftPanelContent = ({titleTranslationKey, subtitleTranslationKey}: Props) => {
  const {t} = useTranslation();

  return (
    <>
      <Box
        display={'block'}
        sx={{
          textAlign: {xs: 'center'},
          marginBottom: 3,
        }}
      >
        <Typography
          marginBottom={3}
          variant={'h1'}
          sx={{
            fontSize: {xs: '2rem', md: '2.5rem'},
            lineHeight: {xs: '2.5rem', md: '3.5rem'},
          }}
        >
          {t(titleTranslationKey)}
        </Typography>
        {subtitleTranslationKey && (
          <Typography
            variant='h3'
            marginBottom={2}
            sx={{
              color: 'black',
              fontSize: {xs: '1.5rem', md: '2rem'},
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '32px',
            }}
          >
            {t(subtitleTranslationKey)}
          </Typography>
        )}
      </Box>
    </>
  );
};
